import { Helmet } from "react-helmet-async"
import { STATIC_URL } from "../settings"

export const metaTags = ({ title, description, image, url }) => {
  return <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={`${STATIC_URL}/${image}`} />
    <meta property="og:url" content={url} />
    <meta property="og:type" content="website" />
    
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={`${STATIC_URL}/${image}`} />
    <meta name="twitter:url" content={url} />
    <meta name="twitter:domain" content="chimeras.world" />
  </Helmet>
}